import React, { useEffect, useRef, useState } from "react";
import styles from "./index.module.scss";
import useForm from "../Form/hooks/useForm";

export default function Switch(props) {
  const { options = [], isMulti = false } = props;
  const isFirstRender = useRef(true);
  const [onChange, formData] = useForm();
  const values = formData[props.name] || [];

  const setStateValue = (v) => {
    if (isMulti) {
      onChange([...values, v.value], props);
    } else {
      onChange([v.value], props);
    }
  };

  const onClickHandler = (el, index, active) => {
    if (!active) {
      setStateValue(el);
    } else {
      onChange(
        typeof values == "string"
          ? values?.split(",").filter((val) => val != el?.value)
          : values?.filter((val) => val != el?.value),
        props
      );
    }
    isFirstRender.current = false;
  };

  const findActiveElement = (el) => {
    if (typeof values == "string") {
      return (
        values
          ?.split(",")
          .map(Number)
          .findIndex((val) => val == el?.value) !== -1
      );
    } else {
      return values?.findIndex((val) => val == el?.value) !== -1;
    }
  };
  return (
    <div className={styles.root}>
      {options.map((el, i) => {
        const isActive = findActiveElement(el);
        return (
          <div
            key={i}
            className={`${styles.item} ${isActive && styles.active} `}
            onClick={() => onClickHandler(el, i, isActive)}
          >
            {el.label}
          </div>
        );
      })}
    </div>
  );
}
